import { call, put, takeEvery } from 'redux-saga/effects';
import { SCAN_CONSTANTS } from '../constants/scanConstants';
import { fastDomainCheckSuccess, fastDomainCheckFailure, getScansSuccess, getScansFailure, getOemScansSuccess, getOemScansFailure } from '../actions/scanActions';
import { fastDomainCheckApi, getOemScansApi, getScansApi } from '../../api/scanApi';
import { toast } from 'react-toastify';

function* fastDomainCheckSaga(action) {
  try {
    const response = yield call(fastDomainCheckApi, action.payload);
    toast.success(response?.data?.message);
    yield put(fastDomainCheckSuccess(response.data));
  } catch (error) {
    yield put(fastDomainCheckFailure(error.response?.data?.message || 'Scan failed'));
  }
}

function* getScansSaga(action) {
  try {
    const response = yield call(getScansApi, action.payload);
    yield put(getScansSuccess(response.data));
  } catch (error) {
    yield put(getScansFailure(error.response?.data?.message || 'Failed to fetch scans'));
  }
}

function* getOemScansSaga(action) {
  try {
    const response = yield call(getOemScansApi, action.payload);
    yield put(getOemScansSuccess(response.data));
  } catch (error) {
    yield put(getOemScansFailure(error.response?.data?.message || 'Failed to fetch OEM scans'));
  }
}

function* scanSaga() {
  yield takeEvery(SCAN_CONSTANTS.FAST_DOMAIN_CHECK_REQUEST, fastDomainCheckSaga);
  yield takeEvery(SCAN_CONSTANTS.GET_SCANS_REQUEST, getScansSaga);
  yield takeEvery(SCAN_CONSTANTS.GET_OEM_SCANS_REQUEST, getOemScansSaga);
}

export default scanSaga;